import { useSubscription } from '@apollo/client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { updateUnseenNotifications } from 'actions/workspace';
import { DELIVERED } from 'constants/notifications';
import onNotificationsUpdated from 'creators/onNotificationsUpdated.graphql';
import { getGraphQLClient } from 'utilities/graphql';

import useDestination from 'hooks/useDestination';
import { useGetSelectedWorkspace } from 'hooks/workspace';

import GetUnseenNotificationCount from './GetUnseenNotificationCount.graphql';

import { UpdateAllNotificationStatuses } from 'components/destination-notifications/UpdateAllNotificationStatuses.gql';

export const onNotificationsUpdate = async ({
  dispatch,
  selectedWorkspace,
}) => {
  const gqlClient = getGraphQLClient();

  // When notifications are generated,
  // mark them as delivered since the client
  // has now received the update.
  await gqlClient.mutate({
    fetchPolicy: 'no-cache',
    mutation: UpdateAllNotificationStatuses,
    variables: { status: DELIVERED },
  });

  // Once we update the notification state,
  // we need to pull the updated cached notification count
  const { data } = await gqlClient.query({
    fetchPolicy: 'no-cache',
    query: GetUnseenNotificationCount,
  });

  if (data?.unseenNotificationsCount) {
    dispatch(
      updateUnseenNotifications(
        selectedWorkspace?.id,
        data.unseenNotificationsCount.count
      )
    );
  }
};

export const useNotifications = () => {
  const dispatch = useDispatch();
  const selectedWorkspace = useGetSelectedWorkspace();
  const showNotificationsInSidebar = useDestination();

  useEffect(() => {
    showNotificationsInSidebar &&
      onNotificationsUpdate({ dispatch, selectedWorkspace });
  }, []);

  useSubscription(onNotificationsUpdated, {
    skip: !showNotificationsInSidebar,
    onSubscriptionData: () => {
      onNotificationsUpdate({ dispatch, selectedWorkspace });
    },
  });
};
